import { render, staticRenderFns } from "./PatientOutreachView.vue?vue&type=template&id=00ab8c22&scoped=true"
import script from "./PatientOutreachView.vue?vue&type=script&lang=js"
export * from "./PatientOutreachView.vue?vue&type=script&lang=js"
import style0 from "./PatientOutreachView.vue?vue&type=style&index=0&id=00ab8c22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ab8c22",
  null
  
)

export default component.exports